import '../../styles/Title.css';

export default function Title() {
    return (<div className="row justify-content-center my-5">
        <div className="col-auto">
            <h1 className='title'>
                <span className='Milliman'> Milliman </span> <span className="reference-repricer"> Medicare Reference Pricer </span>
            </h1>
        </div>
    </div>
    );
}